import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { assetsConst } from 'src/app/core/const/assets.const';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { LoginResponse } from 'src/app/models/loginResponse';
import { validatePayload } from 'src/app/models/validatePayload';
import { VerifyOtpPayload } from 'src/app/models/verifyOtpPayload';

@Component({
  selector: 'megastore-admin-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent {
  @ViewChild('ngOtpInput') ngOtpInput: any;
  assetsConst = assetsConst;
  destroy$: Subject<boolean> = new Subject<boolean>();
  sendagain = false;
  otpTimer = 60;
  intervalHandle: any;
  otp = '';
  type: string | undefined = undefined;

  constructor(
    private _authService: AuthService,
    private _toasterService: ToasterService,
    private _translateService: TranslateService,
    public modal: MatDialogRef<OtpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: validatePayload
  ) {
    this.type = data.type;
    this.startTimer();
  }

  startTimer(): void {
    this.intervalHandle = setInterval(() => {
      if (this.otpTimer > 0) {
        if (this.sendagain) this.sendagain = false;
        this.otpTimer--;
        sessionStorage.setItem(
          'verificationTimerValue',
          JSON.stringify(this.otpTimer)
        );
      } else {
        this.sendagain = true;
        clearInterval(this.intervalHandle);
      }
    }, 1000);
  }

  otpChange(): void {
    let payload: VerifyOtpPayload;
    this.otp = this.ngOtpInput.currentVal || '';
    if (this.otp.length === 4) {
      if (this.data.type === 'email' || this.data.type === 'phone') {
        payload = {
          code: this.otp
        };

        this._authService
          .verifyValidatedOtp(payload)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res: LoginResponse) => {
              this._toasterService.successToastr(
                this._translateService.instant('Verified')
              );
            }
          });
        this.modal.close();
      } else {
        this._toasterService.errToastr(
          this._translateService.instant('AddOTP')
        );
      }
    }
  }

  resendOtp(): void {
    this.sendagain = false;
    this.otpTimer = 59;
    this.startTimer();
    this.otpChange();
  }

  closeDialog(): void {
    this.modal.close(null);
  }
}
